<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ isReassign ? $t('reassign_category') : $t('assign_to_category') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-8
      .text-center.my-8(v-if="isFetching")
        v-progress-circular(width="2" size="30" color="primary" indeterminate)
      template(v-else)
        .text-sm.font-semibold.neutral500--text.mb-2.capitalize {{ $t('category') }}
        yc-select.text-sm.mt-2.round-xl.mb-4(v-model="selectedCategory" :items="categories" itemText="name" itemValue="id" outlined hide-details="auto" dense)
    v-divider

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="save" :loading="isLoading" :disabled="!selectedCategory || isFetching" color="primary" depressed) {{ $t('save') }}

</template>


<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EditServiceCategoryDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    service: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    categories: [],
    selectedCategory: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isReassign () {
      return  this.service.categories.length > 0
    }
  },
  mounted () {
    this.fetchCategories()
    const serviceCategories = this.service.categories
    if (serviceCategories.length) {
      this.selectedCategory = serviceCategories[0].id
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCategories () {
      this.isFetching = true
      this.$axios.get(`/product_categories?company=${this.company.id}&page_size=-1`)
        .then(resp => {
          this.categories = resp.data.results
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isFetching = false
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    save () {
      if (this.isReassign) {
        this.isLoading = true
        const categoryIds = this.service.categories.map(category => category.id).join(',')
        this.$axios.delete(`/clinics/${this.company.slug}/services/${this.service.id}/categories/${categoryIds}`)
          .then(() => {
            this.updateCategories()
          })
          .catch(() => {
            this.isLoading = false
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
      } else {
        this.updateCategories()
      }
    },
    updateCategories () {
      this.isLoading = true
      this.$axios.post(`/clinics/${this.company.slug}/services/${this.service.id}/categories`, { categories: [this.selectedCategory]})
        .then(() => {
          this.showMessage(['success', this.isReassign ? this.$t('success_message.service_reassigned_successfully') : this.$t('success_message.service_assigned_successfully')])
          this.$emit('edited')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
